import React, { useEffect, useState } from 'react';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';

const CommonDatePicker = ({
  value,
  onChange,
  placeholder = 'Please enter date',
  className = 'common-date-picker w-44',
  id = 'date-picker',
  onError,
  max = null,
  min = null,
  width,
  readOnly = false,
  disableActionBar = false,
  sx,
}) => {
  const [localValue, setLocalValue] = useState(value ? new Date(value) : null);
  const [isValid, setIsValid] = useState(true);
  useEffect(() => {
    if (value) {
      const dateValue = dayjs(value).isValid() ? new Date(value) : null;
      setLocalValue(dateValue);
    } else {
      setLocalValue(null);
    }
  }, [value]);

  // Handle date change and calculate formatted date
  const handleDateChange = (newValue) => {
    setLocalValue(newValue);
    const formattedDate = newValue && dayjs(newValue).isValid()
      ? dayjs(newValue).format('YYYY-MM-DD')
      : null;

    if (onChange && (formattedDate || newValue === null)) {
      onChange(newValue, formattedDate);
    }
  };

  // Handle date error
  const handleDateError = (error) => {
    setIsValid(!error);
    if (onError) {
      onError(error);
    }
  };

  return (
    <div className={`common-date-picker w-44 ${className}`}>
      <LocalizationProvider className="w-full" dateAdapter={AdapterDateFns} >
        <DesktopDatePicker
          toolbarPlaceholder={placeholder}
          className="h-[40px] date-picker rounded-md w-full"
          id={id}
          sx={{
            ...sx,
            '& .MuiInputBase-root': {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "8px",
              width: width,
            },
          }}
          readOnly={readOnly}
          maxDate={max}
          minDate={min}
          value={localValue}
          onError={handleDateError}
          onChange={handleDateChange}
          inputFormat={'dd-MM-yyyy'}
          slotProps={{
            actionBar: {
              actions: ['clear'],
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!isValid}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export default CommonDatePicker;